import apiFetch from '@wordpress/api-fetch';

/**
 * イベント詳細ページ専用の処理
 */

export default class EventDetail {
  constructor(_parm) {
    this.eventID = document.querySelector('#js-event-id').value;
    this.elmSelectEvent = document.querySelector('#js-select-event');
    this.elmInputEventData = {
      title: document.querySelector('[name="event_title"]'),
      link: document.querySelector('[name="event_link"]'),
      category: document.querySelector('[name="event_category"]'),
      day: document.querySelector('[name="event_day"]'),
      time: document.querySelector('[name="event_time"]'),
      place: document.querySelector('[name="event_place"]'),
      price: document.querySelector('[name="event_price"]'),
      tel: document.querySelector('[name="event_tel"]'),
    }
    this.elmSubmitBtn = document.querySelector('#js-submit-btn');
  }

  /**
   * 送信ボタンのdisabledを切り替える
   * @param {Boolean} _isDisabled Trueでdisabledにする
   */
  toggleDisabledSubmitBtn(_isDisabled) {
    this.elmSubmitBtn.disabled = _isDisabled;
  }

  /**
   * 各input hiddenにイベント情報をセットする
   * @param {String} _eventId イベントの投稿ID
   */
  setEventData(_eventId) {
    // 送信ボタンをdisabled化
    this.toggleDisabledSubmitBtn(true);
    // API実行して、inputHiddenにイベント情報をセット
    const getUrl = `/wp-json/wp/v2/event?_fields=id,title,link,category,day,time,place,price,tel&include=${_eventId}`;
    apiFetch({
      path: getUrl,
    }).then((_eventData) => {
      // inputに値をセット
      const data = _eventData[0];
      const { title, link, category, day, time, place, price, tel } = this.elmInputEventData;
      title.value = data.title.rendered;
      link.value = data.link;
      category.value = data.category;
      day.value = data.day;
      time.value = data.time;
      place.value = data.place;
      price.value = data.price;
      tel.value = data.tel;
    }).then(() => {
      // 送信ボタンdisabled解除
      this.toggleDisabledSubmitBtn(false);
    }).catch(
      (error) => {
        console.log(error);
        alert('イベント情報の取得に失敗しました。ページを更新してください。');
      });
  }

  /**
   * イベントセレクトボックスにイベント付与
   */
  addEventSelectEvent() {
    this.elmSelectEvent.addEventListener('input', (_ev) => {
      const eventId = this.elmSelectEvent.value;
      this.setEventData(eventId);
    });
  }

  /**
   * イベントセレクトボックスの初期値を、今のイベント詳細ページの選択肢にする
   */
  setDefaultSelectEventOption() {
    const elmOptions = this.elmSelectEvent.options;
    for (let i = 0; i < elmOptions.length; i++) {
      const elmOption = elmOptions[i];
      const value = elmOption.value;
      if (value === this.eventID) {
        elmOption.selected = true;
        break;
      }
    }
  }

  init() {
    // イベント情報のinputHiddenのvalue初期化
    const eventId = this.elmSelectEvent.value;
    this.setEventData(eventId);
    // イベント付与
    this.addEventSelectEvent();
    // イベントセレクトボックスの初期値を、今のイベント詳細ページの選択肢にする
    // wpcf7で入力履歴があったら、そっちが選択されるから、処理を少し待ってから実行
    setTimeout(() => {
      this.setDefaultSelectEventOption();
    }, 1000);
  }

}